export default class Connector {
    constructor (enumName, name) {
        this.enumName = enumName
        this.name = name
        this.config = {}
    }
}